var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v(" © Copyright "),_c('strong',[_c('span',[_vm._v("Josefo")])])]),_c('div',{staticClass:"credits"},[_vm._v(" Designed by "),_c('a',{attrs:{"href":"https://josegutierrez.ck/"}},[_vm._v("José R. Gutierrez")])])])])
}]

export { render, staticRenderFns }